import {inject, Injectable} from '@angular/core'
import {AuthService, EAuthState, IAuthInfo} from './auth.service'
import {filter} from 'rxjs/operators'
import {Observable} from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class BootstrapService {
  private readonly authService = inject(AuthService)

  constructor() {
    // Keep listening to auth states, and when a user is logged in, then
    // get all Mill Settings
    this.authService.authState$.pipe(
      filter((authState: IAuthInfo) => authState.state === EAuthState.authenticated)
    ).subscribe()
  }

  public init(): Observable<boolean> {
    // First thing we ever do, checking if a user is logged in.
    return this.authService.checkLogin()
  }
}
